module.exports = __webpack_public_path__ + "img/akrav_yes.ede34b7f.png";